export const i18nFallbackLang = 'de';
